var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"card tcs-card elevate-2 tcs-top borderless py-3",class:_vm.fluid ? 'container-fluid' : 'container',style:(`width: calc(${_vm.width || '95'}% - ${
		_vm.sideBarWidth + +_vm.fluid * 16
	}px) !important; left: ${Math.floor(_vm.sideBarWidth / 2)}px;`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }